import { ROUTE_IDS, OPERATION_IDS } from '../routes/ids.js';
import { PORTFOLIO_PERFORMANCE_QUERY_ID } from '../descriptors/portfolio-performance-table-registry.js';
export const DATA_RESOURCE_REGISTRY = {
    transactions: {
        id: 'transactions',
        listRouteId: ROUTE_IDS.TRANSACTIONS,
        createRouteId: ROUTE_IDS.TRANSACTION_CREATE,
        detailRouteId: ROUTE_IDS.TRANSACTION_DETAIL,
        listOperationId: OPERATION_IDS.TRANSACTION_LIST,
        readOperationId: OPERATION_IDS.TRANSACTION_GET,
        createOperationId: OPERATION_IDS.TRANSACTION_CREATE,
        listQueryId: 'query.investment.transactions.list',
        readQueryId: 'query.investment.transactions.get',
        createCommandId: 'cmd.investment.transactions.create',
        tableDescriptorId: 'table.investment.transactions',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'bespoke',
        bespokeReason: 'Transaction creation, approval, posting, reversal, repair, and evidence drill-down remain on the dedicated investment lifecycle workspace.',
    },
    'corporate-actions': {
        id: 'corporate-actions',
        listRouteId: ROUTE_IDS.DATA_CORPORATE_ACTIONS,
        createRouteId: ROUTE_IDS.DATA_CORPORATE_ACTION_CREATE,
        detailRouteId: ROUTE_IDS.DATA_CORPORATE_ACTION_DETAIL,
        editRouteId: ROUTE_IDS.DATA_CORPORATE_ACTION_EDIT,
        listOperationId: OPERATION_IDS.CORPORATE_ACTION_LIST,
        readOperationId: OPERATION_IDS.CORPORATE_ACTION_GET,
        createOperationId: OPERATION_IDS.CORPORATE_ACTION_CREATE,
        updateOperationId: OPERATION_IDS.CORPORATE_ACTION_UPDATE,
        listQueryId: 'query.data.corporateActions.list',
        readQueryId: 'query.data.corporateActions.get',
        createCommandId: 'cmd.data.corporateActions.create',
        updateCommandId: 'cmd.data.corporateActions.update',
        tableDescriptorId: 'table.data.corporateActions',
        formDescriptorId: 'form.data.corporateAction',
        createFormDescriptorId: 'form.data.corporateAction.create',
        editFormDescriptorId: 'form.data.corporateAction.edit',
        viewFormDescriptorId: 'form.data.corporateAction.view',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'standard-list-form',
    },
    'fact-batches': {
        id: 'fact-batches',
        listRouteId: ROUTE_IDS.DATA_FACT_BATCHES,
        createRouteId: ROUTE_IDS.DATA_FACT_BATCH_CREATE,
        detailRouteId: ROUTE_IDS.DATA_FACT_BATCH_DETAIL,
        listOperationId: OPERATION_IDS.FACT_BATCHES_LIST,
        readOperationId: OPERATION_IDS.FACT_BATCH_GET,
        createOperationId: OPERATION_IDS.FACT_CREATE,
        listQueryId: 'query.data.factBatches.list',
        readQueryId: 'query.data.factBatches.get',
        createCommandId: 'cmd.data.factBatches.create',
        tableDescriptorId: 'table.data.factBatches',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'standard-list-detail',
    },
    'import-jobs': {
        id: 'import-jobs',
        listRouteId: ROUTE_IDS.DATA_IMPORTS,
        createRouteId: ROUTE_IDS.DATA_IMPORT_UPLOAD,
        detailRouteId: ROUTE_IDS.DATA_IMPORT_DETAIL,
        listOperationId: OPERATION_IDS.IMPORT_LIST,
        readOperationId: OPERATION_IDS.IMPORT_GET,
        createOperationId: OPERATION_IDS.IMPORT_UPLOAD,
        updateOperationId: OPERATION_IDS.IMPORT_COMMIT,
        listQueryId: 'query.data.importJobs.list',
        readQueryId: 'query.data.importJobs.get',
        createCommandId: 'cmd.data.importJobs.upload',
        updateCommandId: 'cmd.data.importJobs.commit',
        tableDescriptorId: 'table.data.importJobs',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'bespoke',
        bespokeReason: 'Import jobs use the staged upload, schema mapping, validation, preview, commit, cancellation, recovery, and reconciliation workflow rather than generic CRUD editing.',
    },
    'reconciliation-runs': {
        id: 'reconciliation-runs',
        listRouteId: ROUTE_IDS.DATA_RECONCILIATION,
        createRouteId: ROUTE_IDS.DATA_RECONCILIATION_CREATE,
        detailRouteId: ROUTE_IDS.DATA_RECONCILIATION_DETAIL,
        listOperationId: OPERATION_IDS.RECONCILIATION_LIST,
        readOperationId: OPERATION_IDS.RECONCILIATION_GET,
        createOperationId: OPERATION_IDS.RECONCILIATION_CREATE,
        listQueryId: 'query.data.reconciliationRuns.list',
        readQueryId: 'query.data.reconciliationRuns.get',
        createCommandId: 'cmd.data.reconciliationRuns.create',
        tableDescriptorId: 'table.data.reconciliationRuns',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'standard-list-detail',
    },
    positions: {
        id: 'positions',
        listRouteId: ROUTE_IDS.DATA_POSITIONS,
        detailRouteId: ROUTE_IDS.DATA_POSITIONS_DETAIL,
        listOperationId: OPERATION_IDS.DATA_POSITIONS_LIST,
        readOperationId: OPERATION_IDS.DATA_POSITIONS_GET,
        listQueryId: 'query.data.positions.list',
        readQueryId: 'query.data.positions.get',
        tableDescriptorId: 'table.data.positions',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'standard-list-detail',
    },
    'cash-positions': {
        id: 'cash-positions',
        listRouteId: ROUTE_IDS.DATA_CASH,
        detailRouteId: ROUTE_IDS.DATA_CASH_DETAIL,
        listOperationId: OPERATION_IDS.DATA_CASH_LIST,
        readOperationId: OPERATION_IDS.DATA_CASH_GET,
        listQueryId: 'query.data.cashPositions.list',
        readQueryId: 'query.data.cashPositions.get',
        tableDescriptorId: 'table.data.cashPositions',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'standard-list-detail',
    },
    clients: {
        id: 'clients',
        listRouteId: ROUTE_IDS.DATA_CLIENTS,
        detailRouteId: ROUTE_IDS.DATA_CLIENT_DETAIL,
        listOperationId: OPERATION_IDS.DATA_CLIENTS_LIST,
        readOperationId: OPERATION_IDS.DATA_CLIENTS_GET,
        listQueryId: 'query.data.clients.list',
        readQueryId: 'query.data.clients.get',
        tableDescriptorId: 'table.data.clients',
        formDescriptorId: 'form.admin.client',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'standard-list-form',
    },
    portfolios: {
        id: 'portfolios',
        listRouteId: ROUTE_IDS.DATA_PORTFOLIOS,
        detailRouteId: ROUTE_IDS.DATA_PORTFOLIO_DETAIL,
        listOperationId: OPERATION_IDS.DATA_PORTFOLIOS_LIST,
        readOperationId: OPERATION_IDS.DATA_PORTFOLIOS_GET,
        listQueryId: 'query.data.portfolios.list',
        readQueryId: 'query.data.portfolios.get',
        tableDescriptorId: 'table.data.portfolios',
        formDescriptorId: 'form.admin.portfolio',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'standard-list-form',
    },
    journals: {
        id: 'journals',
        listRouteId: ROUTE_IDS.DATA_JOURNALS,
        detailRouteId: ROUTE_IDS.DATA_JOURNAL_DETAIL,
        createRouteId: ROUTE_IDS.DATA_JOURNAL_CREATE,
        createOperationId: OPERATION_IDS.JOURNALS_CREATE,
        listOperationId: OPERATION_IDS.JOURNALS_LIST,
        readOperationId: OPERATION_IDS.JOURNALS_GET,
        listQueryId: 'query.data.journals.list',
        readQueryId: 'query.data.journals.get',
        createCommandId: 'cmd.data.journals.create',
        createFormDescriptorId: 'form.accounting.journal.create',
        tableDescriptorId: 'table.data.journals',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'bespoke',
        bespokeReason: 'Journal entry creation, balancing, approval, posting, reversal, and period-lock checks remain on the dedicated accounting workflow surface.',
    },
    'fiscal-periods': {
        id: 'fiscal-periods',
        listRouteId: ROUTE_IDS.DATA_FISCAL_PERIODS,
        listOperationId: OPERATION_IDS.FISCAL_PERIODS_LIST,
        listQueryId: 'query.data.fiscalPeriods.list',
        tableDescriptorId: 'table.data.fiscalPeriods',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'NONE',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'read-only-list',
    },
    'fiscal-years': {
        id: 'fiscal-years',
        listRouteId: ROUTE_IDS.ADMIN_FISCAL_YEARS_LIST,
        createRouteId: ROUTE_IDS.ADMIN_FISCAL_YEAR_CREATE,
        detailRouteId: ROUTE_IDS.ADMIN_FISCAL_YEAR_DETAIL,
        listOperationId: OPERATION_IDS.ACCOUNTING_FISCAL_YEAR_LIST,
        readOperationId: OPERATION_IDS.ACCOUNTING_FISCAL_YEAR_GET,
        createOperationId: OPERATION_IDS.ACCOUNTING_FISCAL_YEAR_CREATE,
        listQueryId: 'query.admin.fiscalYears.list',
        readQueryId: 'query.admin.fiscalYears.get',
        createCommandId: 'cmd.admin.fiscalYears.create',
        tableDescriptorId: 'table.data.fiscalYears',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'bespoke',
        bespokeReason: 'Fiscal year creation uses a calendar-aware date picker, and the detail page hosts period generation and lifecycle actions (close, reopen).',
    },
    'performance-series': {
        id: 'performance-series',
        listRouteId: ROUTE_IDS.DATA_PERFORMANCE,
        listOperationId: OPERATION_IDS.DATA_PERFORMANCE_LIST,
        listQueryId: PORTFOLIO_PERFORMANCE_QUERY_ID,
        tableDescriptorId: 'table.data.performance',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'NONE',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'read-only-list',
    },
    'tax-records': {
        id: 'tax-records',
        listRouteId: ROUTE_IDS.DATA_TAX_RECORDS,
        listOperationId: OPERATION_IDS.TAX_RECORDS_LIST,
        listQueryId: 'query.data.taxRecords.list',
        tableDescriptorId: 'table.data.taxRecords',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'NONE',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'read-only-list',
    },
    'risk-exposures': {
        id: 'risk-exposures',
        listRouteId: ROUTE_IDS.DATA_RISK_EXPOSURES,
        listOperationId: OPERATION_IDS.RISK_EXPOSURES_LIST,
        listQueryId: 'query.data.riskExposures.list',
        tableDescriptorId: 'table.data.riskExposures',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'NONE',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'read-only-list',
    },
    'compliance-breaches': {
        id: 'compliance-breaches',
        listRouteId: ROUTE_IDS.DATA_COMPLIANCE_BREACHES,
        detailRouteId: ROUTE_IDS.DATA_COMPLIANCE_BREACH_DETAIL,
        listOperationId: OPERATION_IDS.COMPLIANCE_BREACHES_LIST,
        readOperationId: OPERATION_IDS.COMPLIANCE_BREACHES_GET,
        listQueryId: 'query.data.complianceBreaches.list',
        readQueryId: 'query.data.complianceBreaches.get',
        tableDescriptorId: 'table.data.complianceBreaches',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'DETAIL',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'standard-list-detail',
    },
    'position-transfers': {
        id: 'position-transfers',
        listRouteId: ROUTE_IDS.DATA_POSITION_TRANSFERS,
        listOperationId: OPERATION_IDS.POSITION_TRANSFERS_LIST,
        readOperationId: OPERATION_IDS.POSITION_TRANSFERS_GET,
        createOperationId: OPERATION_IDS.POSITION_TRANSFERS_REQUEST,
        createCommandId: 'cmd.investment.positionTransfers.request',
        listQueryId: 'query.investment.positionTransfers.list',
        readQueryId: 'query.investment.positionTransfers.get',
        tableDescriptorId: 'table.investment.positionTransfers',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'NONE',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'bespoke',
        bespokeReason: 'Position transfer request/approve/execute/cancel/reverse lifecycle actions remain on the dedicated investment workflow surface.',
    },
    'settlement-instructions': {
        id: 'settlement-instructions',
        listRouteId: ROUTE_IDS.DATA_SETTLEMENT_INSTRUCTIONS,
        listOperationId: OPERATION_IDS.SETTLEMENT_INSTRUCTIONS_LIST,
        readOperationId: OPERATION_IDS.SETTLEMENT_INSTRUCTIONS_GET,
        createOperationId: OPERATION_IDS.SETTLEMENT_INSTRUCTIONS_CREATE,
        createCommandId: 'cmd.settlement.create',
        listQueryId: 'query.settlement.instructions.list',
        readQueryId: 'query.settlement.instructions.get',
        tableDescriptorId: 'table.settlement.instructions',
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        rowActivation: 'NONE',
        authority: 'ORGANIZATION',
        scopeKind: 'ORGANIZATION',
        kind: 'bespoke',
        bespokeReason: 'Settlement confirm/correct/cancel lifecycle actions remain on the dedicated settlement workflow surface.',
    },
};
export function getDataResourceDescriptorById(id) {
    return DATA_RESOURCE_REGISTRY[id];
}
